import { Checkbox, Form } from 'antd';
import { useIntl } from 'react-intl';

export default function DirectSaleSellerOption() {
  const intl = useIntl().formatMessage;
  return (
    <Form.Item name="synthetic" valuePropName="checked" initialValue={true}>
      <Checkbox>
        {intl({ id: 'movementDirectSale.checkbox.synthetic' })}?
      </Checkbox>
    </Form.Item>
  );
}
